(function () {
  /* Show the saving in pounds rather than a percentage, so nobody has to do maths */
  var save = document.querySelector('[data-ws-save]');
  var full = document.querySelector('[data-ws-full]');
  var total = document.querySelector('.ws-pricerow [data-ws-total], #buy [data-ws-total]');
  if (!save || !full || !total) return;
  function num(t) { var m = (t || '').replace(/[^0-9.]/g, ''); return m ? parseFloat(m) : 0; }
  var busy = false;
  function fix() {
    if (busy) return; busy = true;
    var d = num(full.textContent) - num(total.textContent);
    if (d > 0.004) { var txt = 'Save £' + d.toFixed(2); if (save.textContent !== txt) save.textContent = txt; }
    busy = false;
  }
  new MutationObserver(fix).observe(save, { childList: true, characterData: true, subtree: true });
  new MutationObserver(fix).observe(total, { childList: true, characterData: true, subtree: true });
  fix();
})();
